import {
  ChangeDetectionStrategy, Component, DestroyRef, Inject, OnInit, Optional,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule, DIALOG_DATA, DialogRef, IconModule, SimpleInputModule,
} from '@hglobal/common';
import { Enable2FAData } from '@pt/models';
import { ActionsSubject, Store } from '@ngrx/store';
import { ofType } from '@ngrx/effects';
import { filter, tap } from 'rxjs';
import { SmallLogoComponent } from '@pt/components';

import { AuthActions } from '../../store';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    ButtonModule,
    IconModule,
    SimpleInputModule,
    SmallLogoComponent,
  ],
  selector: 'pu-tfa-reset',
  templateUrl: './tfa-reset.component.html',
  styleUrls: ['./tfa-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TfaResetComponent implements OnInit {
  token: string;
  isLoading = false;

  form = this._fb.group({
    code: ['', [Validators.required]],
  });
  errorDictionary: Record<string, string> = {
    apiValidation: 'errors.invalid_recovery_code',
  };

  constructor(
    private _fb: FormBuilder,
    private _store: Store,
    private _actionsSubject: ActionsSubject,
    private _dialogRef: DialogRef,
    private _destroyRef: DestroyRef,
    @Optional() @Inject(DIALOG_DATA) public data: Enable2FAData & { token: string },
  ) {
    this.token = data.token;
  }

  ngOnInit() {
    this._actionsSubject
      .pipe(
        ofType(AuthActions.resetCode.succeededAction),
        tap(() => {
          this.isLoading = false;
          this._dialogRef.close();
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();

    this._actionsSubject
      .pipe(
        ofType(AuthActions.resetCode.failedAction),
        tap(() => (this.isLoading = false)),
        filter(({ error }) => error.code === 'invalid_recovery_code'),
        tap(() => this.form.controls.code.setErrors({ apiValidation: true })),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }

  reset(): void {
    this.isLoading = true;
    this._store.dispatch(AuthActions.resetCode.action({
      payload: {
        ...this.form.value,
        token: this.token,
      },
    }));
  }
}
